<template>
    <div
        v-if="isVisible"
        class="modal fade modal-open"
        tabindex="-1"
        role="dialog"
        ref="modalDialog"
        id="modalDialog"
    >
        <div
            class="modal-dialog"
            ref="modalContent"
            :style="{ top: modalTop + 'px', left: modalLeft + 'px' }"
        >
            <div class="modal-content">
                <div
                    class="modal-header draggable-handle"
                    @mousedown="startDragging"
                >
                    <h3 class="modal-title">
                        <slot name="title"></slot>
                    </h3>
                    <button
                        type="button"
                        class="close close-icon"
                        @click="close"
                    >
                        <span class="cus-close mr-0"></span>
                    </button>
                </div>
                <div class="modal-body">
                    <slot name="body"></slot>
                </div>
                <div
                    v-if="!isFooterEmpty"
                    class="modal-footer justify-content-between"
                >
                    <slot name="footer"></slot>
                </div>
                <div v-else class="modal-footer">
                    <loader v-if="isLoading" :margin="1"></loader>
                    <button
                        type="button"
                        class="btn btn-secondary mr-auto"
                        @click="close"
                        v-if="!isLoading"
                    >
                        {{ cancelBtnTxt }}
                    </button>
                    <slot v-if="!isLoading" name="confirmBtn"></slot>
                    <button
                        type="button"
                        class="btn btn-primary ml-auto"
                        @click="confirm"
                        v-if="!isLoading && isConfirmBtnEmpty"
                        :disabled="isDisableConfirmBtn"
                        :style="{
                            cursor: isDisableConfirmBtn
                                ? 'not-allowed'
                                : 'pointer'
                        }"
                    >
                        {{ confirmBtnTxt }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.modalDialog {
    opacity: 0;
    transition: none;
}

.modal-open {
    overflow-x: hidden;
    overflow-y: auto;
}

.modalDialog.show {
    opacity: 1;
}

.modal-backdrop {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1030;
    background-color: rgba(0, 0, 0, 0.2);
}

.modal-footer {
    width: 100%;
    padding: 14px 15px 15px !important;
}

.close-icon {
    position: relative;
    top: -10px;
    right: -10px;
}

.draggable-handle {
    cursor: move;
}
</style>
<script>
import Loader from "@/module/commons/loader";

export default {
    components: {
        Loader
    },
    computed: {
        isConfirmBtnEmpty() {
            return (
                !this.$slots.confirmBtn || this.$slots.confirmBtn.length === 0
            );
        },
        isFooterEmpty() {
            return !this.$slots.footer || this.$slots.footer.length === 0;
        }
    },
    props: {
        cancelBtnTxt: {
            type: String,
            default: "Cancel"
        },
        confirmBtnTxt: {
            type: String,
            default: "Confirm"
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        isDisableConfirmBtn: {
            type: Boolean,
            default: false
        },
        zIndex: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            isVisible: false,
            dragging: false,
            modalTop: 0,
            modalLeft: 0,
            mouseX: 0,
            mouseY: 0
        };
    },
    methods: {
        async open() {
            this.isVisible = true;
            await this.$nextTick();
            const modal = this.$refs.modalDialog;
            if (modal) {
                modal.classList.add("show");
                modal.style.display = "block";
                await this.$nextTick();
                this.modalTop = modal.offsetTop;
                this.modalLeft = modal.offsetLeft;
                this.appendBackdrop();
                this.$emit("opened");
            }
        },
        close({ skipEmit } = { skipEmit: false }) {
            this.isVisible = false;
            const modal = this.$refs.modalDialog;
            if (modal) {
                modal.classList.remove("show");
                modal.style.display = "none";
                this.removeBackdrop();
                if (!skipEmit) {
                    this.$emit("close");
                }
            }
        },
        confirm() {
            this.$emit("confirm-dialog");
        },
        appendBackdrop() {
            // check if backdrop already exists
            const existingBackdrop = document.querySelector(
                `[${this.$options._scopeId}].modal-backdrop`
            );

            if (existingBackdrop) {
                existingBackdrop.parentNode.removeChild(existingBackdrop);
            }

            const backdrop = document.createElement("div");
            backdrop.classList.add("modal-backdrop");
            backdrop.setAttribute(this.$options._scopeId, "");

            if (this.zIndex) {
                backdrop.style.zIndex = this.zIndex;
            }

            document.body.appendChild(backdrop);
        },
        removeBackdrop() {
            const backdrop = document.querySelector(
                `[${this.$options._scopeId}].modal-backdrop`
            );
            if (backdrop) {
                backdrop.parentNode.removeChild(backdrop);
            }
        },
        startDragging(event) {
            if (event.target.classList.contains("draggable-handle")) {
                this.dragging = true;
                this.mouseX = event.clientX;
                this.mouseY = event.clientY;
                document.addEventListener("mousemove", this.dragModal);
                document.addEventListener("mouseup", this.stopDragging);
            }
        },
        dragModal(event) {
            if (this.dragging) {
                const deltaX = event.clientX - this.mouseX;
                const deltaY = event.clientY - this.mouseY;
                this.modalTop += deltaY;
                this.modalLeft += deltaX;
                this.mouseX = event.clientX;
                this.mouseY = event.clientY;
            }
        },
        stopDragging() {
            this.dragging = false;
            document.removeEventListener("mousemove", this.dragModal);
            document.removeEventListener("mouseup", this.stopDragging);
        }
    }
};
</script>
